const SW_URL = `${process.env.PUBLIC_URL}/sw.js`;

export function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register(SW_URL).then(
        (reg) => console.log("[SW] Registered:", reg.scope),
        (err) => console.warn("[SW] Registration failed:", err)
      );
    });
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((reg) => reg.unregister())
      .catch(console.error);
  }
}
